import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Logout = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/logout">
        <g id="logout">
          <path
            id="Vector"
            d="M10.1616 14.8467H10.075C7.11497 14.8467 5.6883 13.68 5.44164 11.0667C5.41497 10.7933 5.61497 10.5467 5.89497 10.52C6.16164 10.4933 6.41497 10.7 6.44164 10.9733C6.63497 13.0667 7.62164 13.8467 10.0816 13.8467H10.1683C12.8816 13.8467 13.8416 12.8867 13.8416 10.1733V5.82665C13.8416 3.11332 12.8816 2.15332 10.1683 2.15332H10.0816C7.6083 2.15332 6.62164 2.94665 6.44164 5.07999C6.4083 5.35332 6.17497 5.55999 5.89497 5.53332C5.61497 5.51332 5.41497 5.26665 5.43497 4.99332C5.66164 2.33999 7.09497 1.15332 10.075 1.15332H10.1616C13.435 1.15332 14.835 2.55332 14.835 5.82665V10.1733C14.835 13.4467 13.435 14.8467 10.1616 14.8467Z"
          />
          <path
            id="Vector_2"
            d="M10.0007 8.5H2.41406C2.14073 8.5 1.91406 8.27333 1.91406 8C1.91406 7.72667 2.14073 7.5 2.41406 7.5H10.0007C10.2741 7.5 10.5007 7.72667 10.5007 8C10.5007 8.27333 10.2741 8.5 10.0007 8.5Z"
          />
          <path
            id="Vector_3"
            d="M3.89964 10.7333C3.77297 10.7333 3.6463 10.6866 3.5463 10.5866L1.31297 8.35331C1.11964 8.15998 1.11964 7.83998 1.31297 7.64664L3.5463 5.41331C3.73964 5.21998 4.05964 5.21998 4.25297 5.41331C4.4463 5.60664 4.4463 5.92664 4.25297 6.11998L2.37297 7.99998L4.25297 9.87998C4.4463 10.0733 4.4463 10.3933 4.25297 10.5866C4.15964 10.6866 4.0263 10.7333 3.89964 10.7333Z"
          />
        </g>
      </g>
    </svg>
  );
};

Logout.displayName = 'Logout';
